import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custon-date-dialog-component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './custom-date-dialog-component.html',
  styleUrl: './custom-date-dialog-component.scss'
})
export class CustomDateDialogComponent {
  startDate: Date | null;
  endDate: Date | null;
  today = new Date();

  constructor(
    public dialogRef: MatDialogRef<CustomDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { start: Date, end: Date }
  ) {
    this.startDate = data.start;
    this.endDate = data.end;
  }

  apply() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const [start, end] =
      this.startDate <= this.endDate
        ? [this.startDate, this.endDate]
        : [this.endDate, this.startDate];

    this.dialogRef.close({ start, end });
  }
}


